// /**
//  * Product - edit
//  */

// React
import React from 'react';

// react hook form
import {useForm} from 'react-hook-form';

// UI
import {TextField, Grid, Button} from '@material-ui/core';
import RonadIcons from '../../../components/iconComponent';

// Type
type Props = {
  data: any;
  update: (body: any) => void;
  partnerId: number;
};

type Inputs = {
  name: string;
};

export default function Edit(props: Props) {
  const {register, handleSubmit, errors} = useForm<Inputs>();

  const onSubmit = (data: Inputs) => {
    const {name} = data;
    const {partnerId} = props;
    const {id} = props.data;

    props.update({
      name,
      id,
      partnerId,
    });
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={5} alignItems="flex-end">
        <Grid container item xs={4} spacing={1} alignItems="flex-end">
          <Grid item xs={1}>
            <RonadIcons name='user' size={1} />
          </Grid>
          <Grid item xs={11}>
            <TextField
              fullWidth
              id="name"
              name="name"
              defaultValue={props.data?.name}
              label="نام محصول"
              inputRef={register({required: true})}
              error={errors.name && true}
            />
          </Grid>
        </Grid>

        <Grid
          container
          item
          xs={4}
          spacing={1}
          alignItems="flex-end"
          style={{marginTop: 'auto', marginRight: 'auto'}}
        >
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            size="large"
            data-cy="search"
            // disabled={props.loading}
          >
            {`ویرایش`}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
